/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col } from '@design-system/components/grid/grid';

import {
  NewDiscount,
  NewDiscountVM,
} from '../../view-model/newDiscount.viewModel';
import { TimePicker } from '@mui/x-date-pickers';

import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { GlobalStyles } from '@mui/material';
import { fontFamily, space } from '@design-system/tokens';
import { ErrorMessage } from '@client/new/components/Label';
import { toHourDate } from '../../view-model/utils';

const GlobalTimePickerStyles = () => (
  <GlobalStyles
    styles={{
      '.MuiDialogActions-root': {
        padding: `${space.s} !important`,
        fontFamily: fontFamily.visuelt,
      },
    }}
  />
);

export const TimeInput = (
  p: Pick<NewDiscountVM, 'register' | 'values'> & { width?: number },
) => {
  const callChange = <T extends keyof NewDiscount>(
    name: T,
    value: NewDiscount[T],
  ) => p.register(name).onChange({ target: { name, value } } as any);
  const error =
    p.register('expirationHour').error ||
    p.register('expirationMinute').error ||
    p.register('expirationDayTime').error;

  const value = toHourDate(p.values);
  return (
    <>
      <GlobalTimePickerStyles />
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Col
          style={{
            marginTop: '1px',
            ...(p.width ? { width: p.width + 'px' } : {}),
          }}
        >
          <TimePicker
            minTime={new Date(0, 0, 0, 0, 0)}
            maxTime={new Date(0, 0, 0, 23, 59)}
            ampmInClock
            sx={{
              fontFamily: fontFamily.visuelt,

              '>div': {
                fontFamily: fontFamily.visuelt,

                height: '45px',
                borderWidth: '2px',
                borderRadius: '10px',
                borderColor: '#e4e4e4',
              },
            }}
            slotProps={{
              popper: {
                sx: {
                  '& .MuiPickersMonth-monthButton': {
                    fontFamily: fontFamily.visuelt,
                  },
                  '& .MuiPickersYear-yearButton': {
                    fontFamily: fontFamily.visuelt,
                  },
                  '& .MuiPickersCalendarHeader-label': {
                    fontFamily: fontFamily.visuelt,
                  },
                },
              },

              textField: {
                InputProps: { sx: { fontFamily: fontFamily.visuelt } },
                error: error !== undefined,
              },
            }}
            value={value}
            onChange={(newValue) => {
              if (!newValue) return;
              const hours = newValue.getHours();
              callChange('expirationHour', hours > 12 ? hours - 12 : hours);
              callChange('expirationMinute', newValue.getMinutes());
              callChange('expirationDayTime', hours >= 12 ? 'PM' : 'AM');
            }}
          />
          <ErrorMessage content={error} />
        </Col>
      </LocalizationProvider>
    </>
  );
};
